<mat-toolbar class="p-0 mat-elevation-z1 barra">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && !rightNavbar"
                (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <img class="logo-text" src="assets/images/logos/Coexito.png">
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/images/logos/fuse.svg">
                </div>
            </div>

            <div class="px-8 px-md-16">
                <!--
                    <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
                -->
            </div>

        </div>
        <button mat-button class="user-button" routerLink="/informacionCliente">
            <div fxLayout="row" *ngIf="showCliente" class="py-14 px-8 my-0 toolbar-text">
                <div>Cliente: {{cliente.identificacion + ' - ' + cliente.codigoSucursal}}</div>
                <div>{{cliente.nombre}}</div>
                <div>Dirección: {{cliente.direccion}}</div>
            </div>
        </button>

        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

            <div *ngIf="showLogisticaReversiva" class="toolbar-separator" fxHide fxShow.gt-xs></div>

            <button *ngIf="showLogisticaReversiva" mat-icon-button class="quick-panel-toggle-button"
                routerLink="/solicitudLogisticaReversiva/resumen">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon matBadge="{{totalItem}}" matBadgeColor="badge" class="s-30 secondary-text">shopping_cart</mat-icon>
                </div>
            </button>

            <div *ngIf="showGarantia" class="toolbar-separator" fxHide fxShow.gt-xs></div>

            <button *ngIf="showGarantia" mat-icon-button class="quick-panel-toggle-button"
                routerLink="/solicitudGarantia/resumen">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon matBadge="{{totalItem}}" matBadgeColor="badge" class="s-30 secondary-text">shopping_cart</mat-icon>
                </div>
            </button>

            <div *ngIf="showRotacion" class="toolbar-separator" fxHide fxShow.gt-xs></div>

            <button *ngIf="showRotacion" mat-icon-button class="quick-panel-toggle-button"
                routerLink="/solicitudRotacion/resumen">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon matBadge="{{totalItem}}" matBadgeColor="badge" class="s-30 secondary-text">shopping_cart</mat-icon>
                </div>
            </button>

            <div *ngIf="showTomarPedido" class="toolbar-separator" fxHide fxShow.gt-xs></div>

            <button *ngIf="showTomarPedido" mat-icon-button class="quick-panel-toggle-button"
                routerLink="/tomarPedido/resumen">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon matBadge="{{totalItem}}" matBadgeColor="badge" class="s-30 secondary-text">shopping_cart</mat-icon>
                </div>
            </button>

            <div *ngIf="showRecaudo" class="toolbar-separator" fxHide fxShow.gt-xs></div>
            
            <button *ngIf="showRecaudo" mat-icon-button class="quick-panel-toggle-button"
                routerLink="/capturarRecaudo/resumen">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon matBadge="{{totalItem}}" matBadgeColor="badge" class="s-30 secondary-text">shopping_cart</mat-icon>
                </div>
            </button>

            <div class="toolbar-separator" *ngIf="showMenuDerecho" fxHide fxShow.gt-xs></div>

            <button *ngIf="showMenuDerecho" mat-icon-button class="quick-panel-toggle-button"
                (click)="toggleSidebarOpen('quickPanel')">
                <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

            <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && rightNavbar"
                (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

        </div>

    </div>

</mat-toolbar>